import React from 'react';
import './Mantenimiento.css';

function Mantenimiento() {
  return (
    <div className="mantenimiento-container">
      <div className="mantenimiento-content">
        <div className="mantenimiento-icon">
          <svg width="120" height="120" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2L2 7l10 5 10-5-10-5z" />
            <path d="M2 17l10 5 10-5" />
            <path d="M2 12l10 5 10-5" />
          </svg>
        </div>
        <h1>Sistema en Mantenimiento</h1>
        <p className="mantenimiento-message">
          Estamos realizando mejoras en el sistema para ofrecerte una mejor experiencia.
        </p>
        <p className="mantenimiento-submessage">
          Por favor, vuelve a intentarlo en unos minutos. Gracias por tu paciencia.
        </p>
      </div>
    </div>
  );
}

export default Mantenimiento;
